import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-689cb75b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bill-tips" }, "非最终费用，最终支付以实际为准", -1))
const _hoisted_3 = { class: "bill-detail van-hairline--top" }
const _hoisted_4 = { class: "pay-type" }
const _hoisted_5 = { class: "xag-flex-lr" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "配件总价(原价)", -1))
const _hoisted_7 = { class: "xag-flex-lr" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "配件费用", -1))
const _hoisted_9 = { class: "xag-flex-lr" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "工时总价(原价)", -1))
const _hoisted_11 = { class: "xag-flex-lr" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "维修工时费用", -1))
const _hoisted_13 = {
  key: 0,
  class: "bill-detail van-hairline--top"
}
const _hoisted_14 = { class: "xag-flex-lr" }
const _hoisted_15 = { class: "discount-price" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "price-tips" }, "根据设备享有的售后权益以及维修故障情況判定", -1))
const _hoisted_17 = { class: "bill-total van-hairline--top" }
const _hoisted_18 = { class: "total-price" }
const _hoisted_19 = { class: "price" }
const _hoisted_20 = {
  key: 0,
  class: "price-tips"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "claims-tip fix-tip" }, "本次理赔抵扣后，预计意外机损保险", -1))
const _hoisted_22 = { class: "claims-tip" }

import { ref, computed, withDefaults } from 'vue'
import BlockkWrapper from '../block-wrap.vue'
import { MalfunctionRepairRepairOrderPayOrderInfo } from '@/types/malfunction-repair'

export default /*#__PURE__*/_defineComponent({
  __name: 'detail-bill-block',
  props: {
    payInfo: { default: () => null },
    show: { type: Boolean, default: false },
    isShowClaims: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { payInfo: MalfunctionRepairRepairOrderPayOrderInfo, show: boolean, isShowClaims: boolean };


const isPayed = computed(() => {
  let payStatus = props.payInfo.pay_status
  return payStatus === 4
})
const waitText = computed(() => {
  if (props.show) {
    return ''
  }
  return '暂无报价'
})

const pay_status_text = computed(() => {
  return props.payInfo.pay_status === 1 ? '客户自费部分' : props.payInfo.pay_status_text
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BlockkWrapper, {
    title: "账单费用",
    waitText: _unref(waitText)
  }, {
    default: _withCtx(() => [
      (props.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(__props.payInfo.pay_type_text), 1),
              _createElementVNode("ul", null, [
                _createElementVNode("li", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("p", null, "¥ " + _toDisplayString(__props.payInfo.original_mate_amount.toFixed(2)), 1)
                ]),
                _createElementVNode("li", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("p", null, "¥ " + _toDisplayString(__props.payInfo.mate_amount.toFixed(2)), 1)
                ]),
                _createElementVNode("li", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("p", null, "¥ " + _toDisplayString(__props.payInfo.original_hourly_amount.toFixed(2)), 1)
                ]),
                _createElementVNode("li", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("p", null, "¥ " + _toDisplayString(__props.payInfo.hourly_amount.toFixed(2)), 1)
                ])
              ])
            ]),
            (__props.payInfo.service_type)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", _hoisted_14, [
                      _createElementVNode("p", null, _toDisplayString(__props.payInfo.service_type_text), 1),
                      _createElementVNode("p", _hoisted_15, "- ¥ " + _toDisplayString(__props.payInfo.discount_amount), 1)
                    ])
                  ]),
                  _hoisted_16
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createTextVNode(_toDisplayString(_unref(pay_status_text)) + "： ", 1),
                _createElementVNode("span", _hoisted_19, "￥ " + _toDisplayString(__props.payInfo.pay_amount.toFixed(2)), 1)
              ]),
              (!_unref(isPayed))
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, "费用明细请查看维修配件清单"))
                : _createCommentVNode("", true),
              (__props.isShowClaims)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      _createTextVNode(" 剩余额度"),
                      _createElementVNode("span", null, "￥" + _toDisplayString(__props.payInfo.remain_amount), 1)
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["waitText"]))
}
}

})